import { render, staticRenderFns } from "./TopicAnswerMultiple.vue?vue&type=template&id=1a8a4a1b&scoped=true"
import script from "./TopicAnswerMultiple.vue?vue&type=script&lang=js"
export * from "./TopicAnswerMultiple.vue?vue&type=script&lang=js"
import style0 from "./TopicAnswerMultiple.vue?vue&type=style&index=0&id=1a8a4a1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a4a1b",
  null
  
)

export default component.exports